import { CircularProgress, Stack, Typography } from '@mui/material';

interface TablesProcessingStatusProps {
  label: string;
}

// What the run in flight is doing, shown above the tables while it processes. The
// tables fill in underneath as columns complete.
export const TablesProcessingStatus = ({ label }: TablesProcessingStatusProps) => (
  <Stack
    direction="row"
    alignItems="center"
    spacing={2}
    role="status"
    data-testid="analysis-tables-processing-status"
  >
    <CircularProgress size={16} aria-hidden />
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
  </Stack>
);
